<template>
  <section class="algorithm-panel principle-panel">
    <div class="panel-title">算法原理说明</div>
    <p class="intro-text">
      采用模糊数学聚类算法处理农业物联网数据中的噪声和不确定性，融合土壤墒情、温度、湿度、光照、NDVI长势指数等多源数据，对农作物生长环境进行分层聚类分析，识别不同田间地块的生长状态差异，支持精准灌溉、差异化施肥和病虫害预警保护。
    </p>
    <div class="flow-row">
      <span v-for="(item, index) in steps" :key="item" class="flow-step">
        {{ item }}
        <i v-if="index < steps.length - 1"></i>
      </span>
    </div>
  </section>
</template>

<script setup>
const steps = ["数据采集", "噪声过滤", "生长分层", "精准管护"];
</script>

<style lang="less" scoped>
.algorithm-panel {
  position: relative;
  min-height: 0;
  padding: 30px 58px 42px;
  box-sizing: border-box;
  border: 1px solid rgba(64, 255, 238, 0.72);
  background:
    radial-gradient(circle at 68% 0, rgba(31, 214, 190, 0.14), transparent 38%),
    linear-gradient(180deg, rgba(4, 51, 50, 0.5), rgba(3, 25, 31, 0.82));
  box-shadow: inset 0 0 34px rgba(30, 242, 224, 0.13), 0 0 16px rgba(0, 229, 214, 0.13);
  display: flex;
  flex-direction: column;
  gap: 30px;
  justify-content: flex-start;
}

.algorithm-panel::before,
.algorithm-panel::after {
  content: "";
  position: absolute;
  width: 22px;
  height: 22px;
  border-color: #54fff0;
  border-style: solid;
}

.algorithm-panel::before {
  left: -1px;
  bottom: -1px;
  border-width: 0 0 3px 3px;
}

.algorithm-panel::after {
  right: -1px;
  top: -1px;
  border-width: 3px 3px 0 0;
}

.panel-title {
  position: relative;
  padding-left: 26px;
  color: #f3fcff;
  font-size: 34px;
  font-weight: bold;
  line-height: 42px;
  text-align: left;

}

.panel-title::before {
  content: "";
  position: absolute;
  top: 6px;
  left: 0;
  width: 6px;
  height: 40px;
  background: #5ffff0;
  box-shadow: 0 0 12px rgba(95, 255, 240, 0.8);
}

.intro-text {
  color: #e6ffff;
  font-size: 28px;
  font-weight: bold;
  line-height: 48px;
  text-align: left;
}

.flow-row {
  display: flex;
  align-items: center;
  gap: 50px;
}

.flow-step {
  position: relative;
  flex: 1;
  // min-width: 162px;
  height: 46px;
  padding: 0 22px;
  box-sizing: border-box;
  border: 1px solid rgba(101, 255, 241, 0.75);
  border-radius: 4px;
  background: linear-gradient(180deg, rgba(17, 102, 100, 0.88), rgba(6, 61, 67, 0.88));
  color: #eaffff;
  font-size: 23px;
  font-weight: bold;
  line-height: 44px;
  text-align: center;
  box-shadow: inset 0 0 18px rgba(96, 255, 241, 0.16), 0 0 10px rgba(53, 250, 232, 0.18);
}

.flow-step i {
  position: absolute;
  top: 14px;
  right: -38px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 24px solid #5ffff0;
  filter: drop-shadow(0 0 6px rgba(95, 255, 240, 0.8));
}
</style>
